/**
 * Montagem da chamada real da fila de sugestões do consolidador.
 *
 * Só manda o escopo que o backend REALMENTE filtra hoje: `id_cliente_app` e `limit`. Nem
 * `tabela_referencia` nem `id_entidade_alvo` entram — adivinhar a semântica (CSV? igualdade?) é
 * aposta cara: no dia em que o filtro existir com igualdade simples, um valor que não case devolve
 * fila vazia e cada badge lê zero apurado, que é exatamente o falso-negativo que o resto do código
 * existe para impedir. O recorte por entidade é feito no cliente, em `utils/suggestions-fila/`, e
 * cada parâmetro entra aqui quando o contrato dele existir de fato.
 *
 * Escopo ausente simplesmente não vira parâmetro: `formatQueryParams` descarta null/undefined.
 */
import { formatQueryParams } from '@utils/Format'
import { intelligenceV2 } from '@modules/aawz-intelligence-v2/constants/URL'

export const LIMITE_PADRAO = 200

export const urlDaFila = ({ idClienteApp = null, limit = LIMITE_PADRAO } = {}) =>
  intelligenceV2.suggestions +
  formatQueryParams({
    id_cliente_app: idClienteApp,
    limit,
  })
